import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

import { computed } from 'vue'

interface IProps {
  icon?: string
  iconable?: boolean
  isRightIcon?: boolean
  label?: string
  model?: 'primary' | 'secondary' | 'link'
  size?: 'lg' | 'md' | 'sm'
  disable?: boolean
  outline?: boolean
  customColor?: string
  iconSize?: string
  error?: boolean
  iconHoverable?: boolean

  color?: string
  customTextColor?: string
  customHoverTextColor?: string
}

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KBtn' },
  __name: 'KBtn',
  props: {
    icon: { default: '' },
    iconable: { type: Boolean, default: true },
    isRightIcon: { type: Boolean, default: false },
    label: { default: '' },
    model: { default: 'primary' },
    size: { default: 'lg' },
    disable: { type: Boolean, default: false },
    outline: { type: Boolean, default: false },
    customColor: { default: '' },
    iconSize: { default: '' },
    error: { type: Boolean, default: false },
    iconHoverable: { type: Boolean, default: false },
    color: { default: 'dark-bg-20' },
    customTextColor: { default: 'white' },
    customHoverTextColor: { default: 'white' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "a14746d8": (mainColor.value),
  "ff0ab4c0": (textColor.value),
  "v4a9e515d": (hoverColor.value),
  "de4679a0": (hoverTextColor.value)
}))



const props = __props

const mainColor = computed(() => convertColorCodeToCss(props.color) || 'var(--dark-bg-20)')

const hoverColor = computed(() => {
  if (!props.color) return 'rgba(0, 0, 0, 0.7)'
  return `color-mix(in srgb, ${mainColor.value} 80%, white)`
})

const textColor = computed(() => {
  return props.customTextColor
    ? convertColorCodeToCss(props.customTextColor)
    : props.model === 'primary'
    ? 'white'
    : mainColor.value
})

const hoverTextColor = computed(() => convertColorCodeToCss(props.customHoverTextColor))

function convertColorCodeToCss(color: string) {
  if (!color || typeof color !== 'string') return ''

  if (color.includes('#') || color.includes('rgb')) return color
  else return `var(--${color})`
}

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    "no-caps": "",
    unelevated: "",
    class: _normalizeClass(["k-button", [
      `${__props.model}-button k-button--${__props.size}`,
      __props.error && 'error-button',
      __props.disable && 'disable-button',
      __props.model !== 'link'
        ? __props.label
          ? [
              {
                'q-px-xl q-py-md': __props.size === 'lg',
                'q-px-lg q-py-12': __props.size === 'md',
                'q-px-md q-py-sm': __props.size === 'sm',
              },
            ]
          : {
              'q-pa-md': __props.size === 'lg',
              'q-pa-sm': __props.size !== 'lg',
            }
        : 'q-pa-none',

      { 'k-button--text': __props.label },
    ]]),
    outline: __props.outline,
    ripple: __props.model !== 'link'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["k-button__text-box transition row items-center", [__props.size !== 'sm' ? 'gap-sm' : 'gap-xs', { reverse: __props.isRightIcon }]])
      }, [
        (__props.label)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["fw-500 q-mb-none", [
          `k-button--label-${__props.size}`,
          __props.customColor && `text-${__props.customColor}`,
          {
            'fs-17px': __props.size === 'lg',
            'fs-15px': __props.size === 'md',
            'fs-13px': __props.size === 'sm',
          },
        ]])
            }, _toDisplayString(__props.label), 3))
          : _createCommentVNode("", true),
        ((__props.model === 'link' || __props.icon) && __props.iconable)
          ? (_openBlock(), _createBlock(_component_KIcon, {
              key: 1,
              name: __props.icon ? __props.icon : 'arrow-right',
              class: _normalizeClass({ 'rotate-180': __props.isRightIcon && __props.model === 'link' && !__props.icon }),
              color: __props.customColor || 'inherit',
              size: __props.iconSize ? __props.iconSize : __props.size !== 'sm' ? '24px' : '20px',
              hoverable: __props.iconHoverable
            }, null, 8, ["name", "class", "color", "size", "hoverable"]))
          : _createCommentVNode("", true)
      ], 2),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["outline", "class", "ripple"]))
}
}

})